import { FormikErrors } from 'formik';
import { FormValues } from '@ahmdigital/form-validation/lib/validators/types';
import { has, some } from 'lodash/fp';

const hasErrors = (fieldNames: string[], errors: FormikErrors<FormValues> | null): boolean =>
  some((fieldName) => has(fieldName, errors), fieldNames);

export default hasErrors;
